import { DataGridProProps } from "@mui/x-data-grid-pro";

import { DataType } from "shared/types";

import type { RowData, SchemaEntry } from "./types";

export const WIDE_COLUMN_WIDTH = 320;
export const MIN_COLUMN_WIDTH = 120;

export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_ROW_HEIGHT = 46;

// Room for a full empty state — icon, heading, body, and a button — inside the grid body.
export const DEFAULT_OVERLAY_HEIGHT = 400;
export const DEFAULT_GET_ROW_ID = (row: RowData) => row.ID;

export const ACTIONS_COLUMN: Omit<SchemaEntry, "label"> = {
  accessor: "actions",
  dataType: DataType.JSX,
  hideFilter: true,
  sortable: false,
  align: "center",
};

export const FOOTER_HEIGHT_PX = 68;

/** Height of the SmartMaterialTable column-header row (set via CSS). Used as
 *  the sticky top-offset for inner tables nested inside Smart Group panels. */
export const SMART_TABLE_HEADER_OFFSET_PX = -6;

// Set by useHorizontalOverflowScroll and consumed by the right-pinned column
// styles, which have to be counter-translated by hand while the grid's own
// horizontal scroll is replaced by transforms.
export const PINNED_RIGHT_SHIFT_VAR = "--pinned-right-shift";

// MUI marks the grid root as toolbar-less only when the toolbar slot is null, and only on that mark rounds the
// first and last header cells to the root's corner, so that a focus outline follows the corner instead of being
// clipped by it. Its slot type does not admit null, hence the cast at this boundary.
export const NO_TOOLBAR = null as unknown as NonNullable<
  DataGridProProps["slots"]
>["toolbar"];
